import React from 'react';
import {connect} from 'react-redux';
import ImageUploaderAccordion from 'components/images/ImageUploaderAccordion';
import {createResourcePageItemsSelector} from 'resources/selectors';
import formContextShape from "components/forms/ResourceFormContextShape";
import {breakImagesPageName} from "pages/EditBreak/utils";
import {removeImageFromCurrentBreakAction} from "../pages/Images/actions";
import {pickOriginalAction, startEditImageAction} from "pages/Images/actions";

const getPageItems = createResourcePageItemsSelector(breakImagesPageName);

const MAX_FILES_PER_UPLOAD = 50;

const mapStateToProps = (state) => {
    return {
        images: getPageItems(state.resources)
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    let brk = ownProps.formProxy.currentBaseResource;
    return {
        onImageClicked: (imageId) => dispatch(startEditImageAction(imageId)),
        onBrowse: () => dispatch(pickOriginalAction(brk.resourceId, {maxFiles: MAX_FILES_PER_UPLOAD})),
        onRemoveButtonClicked: (image) => dispatch(removeImageFromCurrentBreakAction(image))
    };
};

const BreakImageUploaderAccordion = connect(mapStateToProps, mapDispatchToProps)(ImageUploaderAccordion);

BreakImageUploaderAccordion.propTypes = {
    formProxy: formContextShape.isRequired
};

export default BreakImageUploaderAccordion;



// WEBPACK FOOTER //
// ./public/hoc/BreakImageUploaderAccordion.jsx